// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/crosshair.js';

import { paths } from '../generated/crosshair';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('crosshair', Original, paths);
